import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams, useLocation } from 'react-router-dom'; 
import Cookies from 'universal-cookie';
 

const PaymentResult = () => {
  const navigate = useNavigate();
   const [conversation_number, setconversation_number] = useState('');
/*
  const { id } = useParams();
  console.log("id success: "+  id );  
*/
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const paymentStatus = queryParams.get("paymentStatus");
  const merchantOrderId = queryParams.get("merchantOrderId");
  const currency = queryParams.get("currency");
  const amount = queryParams.get("amount");

  const get_conversation_number = async () => {

    const merchantOrderIdjson = { merchantOrderId: merchantOrderId };
    const TokenA = localStorage.getItem('CustomerTokenA');
    try {
      const response = await fetch(process.env.REACT_APP_API_BASE_URL+'/api/customer/get_conversation_num_related_to_orderid', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${TokenA}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(merchantOrderIdjson)
      });
     
      if (response.ok) {
        const data = await response.json();
        console.log('conversation_number :', data);

        setconversation_number(data.converstion_num);
    
      }
    } catch (error) {
      console.error('Error fetching my data:', error);
    }
  };


 const render_success = () => (
        <>
          <div className="text-center mb-8">
          <h1   style={{marginTop: '12px',marginBottom: '12px'}}  className="text-white text-3xl font-bold mb-2">
           تم الدفع بنجاح 
          </h1>
       
          </div>

          <div>
         
            <p style={{ marginTop: '12px', marginBottom: '12px' }} className="text-white opacity-80 mb-2">
              Order ID: {merchantOrderId}
              </p>
            <p style={{ marginTop: '12px', marginBottom: '12px' }} className="text-white opacity-80 mb-2">
              Amount: {amount} EGP
              </p>
          </div>


          <div className="mt-6 text-center space-y-3"> {/* ADDED: space-y-3 for better spacing */}
                      <p style={{ marginTop: '12px', marginBottom: '12px' }} className="text-white opacity-80 mb-2">
            كود الحجز الخاص بك هو: <span style={{ fontWeight: 'bold', fontSize: '18px' }}>{conversation_number}</span>
            </p>
            <p style={{ marginTop: '12px', marginBottom: '12px' }} className="text-white opacity-80 mb-2">
            قبل 15 دقيقة من  الوقت الذي تم حجزه ، يرجى التواجد       
            </p>
        

      

  

          </div>
        </>
    );

 const render_not_success = () => (
  <>
    <div className="text-center mb-8">
    <h1   style={{marginTop: '12px',marginBottom: '12px'}}  className="text-white text-3xl font-bold mb-2">
      لم يتم الدفع بنجاح 
    </h1>
  
    </div>

 


    <div className="mt-6 text-center space-y-3"> {/* ADDED: space-y-3 for better spacing */}
  
      <p style={{ marginTop: '12px', marginBottom: '12px' }} className="text-white opacity-80 mb-2">
          يرجى إعادة المحاولة و في حالة استمرار المشكلة ، يرجى الاتصال بالدعم الفني
      </p>
  





    </div>
  </>
    );

  useEffect(() => {
    get_conversation_number();
  }, []);

    const cookies = new Cookies();

   // cookies.set('points1smsssur', user, { path: '/' });
    
  /*
  var user_cookie= cookies.get('points1smsssur'); 
  var pass_cookie= cookies.get('points1smsssprivrw'); 
  */

 
  const handleRegister = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setSuccessMessage(''); // ADDED: Clear success message

    // Validate passwords match
    if (registerData.password !== registerData.confirmPassword) {
      setError('كلمات المرور غير متطابقة');
      setIsLoading(false);
      return;
    }

    // Validate age
    if (registerData.age && (isNaN(registerData.age) || registerData.age < 1 || registerData.age > 120)) {
      setError('يرجى إدخال عمر صحيح');
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(process.env.REACT_APP_API_BASE_URL+'/api/customer/register', {
        method: 'POST',
        headers: {
                   'Content-Type': 'application/json',
          'Accept': 'application/json'  // Add this`
        },
        body: JSON.stringify({
          name: registerData.fullName,
          email: registerData.email,
          phone: registerData.phone,
          age: registerData.age ? parseInt(registerData.age) : null,
          gender: registerData.gender || null,
          password: registerData.password
        }),
      });

      const data = await response.json();

      if (response.ok) {
        // MODIFIED: Use success message state instead of alert
        setSuccessMessage(`تم إنشاء حسابك بنجاح! كود التليجرام الخاص بك: ${data.telegram_code} - احفظ هذا الكود لتسجيل الدخول مستقبلاً`);
        
        // ADDED: Auto-fill login form with the new telegram code
        setFormData({
          telegramCode: data.telegram_code,
          password: registerData.password
        });
        
        // Clear form and switch to login
        setRegisterData({
          fullName: '',
          email: '',
          phone: '',
          age: '',
          gender: '',
          password: '',
          confirmPassword: ''
        });
        setIsRegistering(false);
      } else {
        setError(data.message || 'حدث خطأ في إنشاء الحساب');
      }
    } catch (err) {
      console.error('Registration error:', err);
      setError('حدث خطأ في الاتصال بالخادم');
    } finally {
      setIsLoading(false);
    }
  };
// 
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 via-blue-600 to-teal-500 flex-center"> {/* REVERTED: Back to your original working class */}
      <div className="glass p-8 m-4 w-full max-w-md">

    {
      render_success() && paymentStatus==="SUCCESS" ? render_success() : render_not_success()
    }
      </div>
    </div>
  );
};

export default PaymentResult;